import { useMemo, useState } from 'react';

import { FNodeTypesEnum } from '@spazious/dollhouse-fsetup';
import { Translate } from '@spazious/dollhouse-i18n';
import { CheckboxProps, Flex, Switch, Typography } from '@spazious/dollhouse-uikit';
import { useEventCallback } from '@spazious/react-hooks';

import { useSelectedNodes } from '../../hooks/index.js';
import { useFeatures } from '../Features/index.js';
import { RotationField } from '../InspectorPanel/RotationField.js';

export interface RotationInputProps {}

export const RotationInput: React.FC<RotationInputProps> = () => {
  const [groupRotation, setGroupRotation] = useState(true);
  const { hasFeature } = useFeatures();
  const propsReadOnly = !hasFeature('graphs.setup.node.props:editable');
  const selectedNodes = useSelectedNodes();
  const nodes = useMemo(
    () =>
      selectedNodes.map((node) =>
        node?.type === FNodeTypesEnum.Furniture && node?.originator ? node.originator : node
      ),
    [selectedNodes]
  );

  const handleCheckboxChange = useEventCallback<PickProp<CheckboxProps, 'onChange'>>((evt) => {
    setGroupRotation(!evt.target.checked);
  });

  return (
    <Flex column={true} gap="var(--spacing-gap)">
      <RotationField
        disabled={propsReadOnly}
        format={(value: number) => ((180 / Math.PI) * value).toFixed(0)}
        group={groupRotation}
        max={360}
        min={0}
        parse={(value: string) => (parseFloat(value) / 180) * Math.PI}
        selectOriginator={true}
        step={1}
      />
      {nodes.length > 1 && (
        <Flex gap="var(--spacing-gap)" justifyContent="space-between">
          <Typography>
            <Translate>Rotate items individually</Translate>
          </Typography>
          <Switch checked={!groupRotation} name="Rotation" onChange={handleCheckboxChange} />
        </Flex>
      )}
    </Flex>
  );
};
